import { Phase } from "../hooks/useTrainingEngine";

export function TimerRing(props: { phase: Phase; progress01: number; timeLabel: string }) {
    const size = 300;
    const stroke = 8;
    const r = (size - stroke) / 2;
    const c = 2 * Math.PI * r;
    const dash = Math.max(0, Math.min(1, props.progress01)) * c;

    const phaseColor =
        props.phase === "work" ? "var(--gold)" : props.phase === "rest" ? "var(--rest)" : "var(--muted)";

    return (
        <div className="relative w-[min(82vw,320px)] aspect-square grid place-items-center">
            {/* spotlight */}
            <div className="absolute inset-0 rounded-full bg-[radial-gradient(circle,rgba(201,162,39,0.08)_0%,transparent_65%)]" />

            <svg viewBox={`0 0 ${size} ${size}`} className="absolute inset-0 drop-shadow-[0_0_18px_rgba(201,162,39,0.18)]">
                {/* base ring */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={r}
                    stroke="var(--border)"
                    strokeWidth={stroke}
                    fill="transparent"
                />
                {/* progress ring */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={r}
                    stroke={phaseColor}
                    strokeWidth={stroke}
                    fill="transparent"
                    strokeLinecap="round"
                    strokeDasharray={`${dash} ${c - dash}`}
                    transform={`rotate(-90 ${size / 2} ${size / 2})`}
                    style={{
                        filter: `drop-shadow(0 0 12px ${phaseColor}80)`,
                        transition: 'stroke var(--dur-base) var(--ease-inout)'
                    }}
                />
            </svg>

            <div className="relative text-center">
                <div className="text-[64px] leading-none font-bold tracking-[-0.02em] text-[var(--text)] tabular-nums">
                    {props.timeLabel}
                </div>
            </div>
        </div>
    );
}
